var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'query-string';
const basePath = '/CustomFields';
export const customFieldsDataProvider = context => {
    return {
        // The CustomFields API route does not care about pagination or sorting
        // so we ignore those parameters
        getList: async ({ filter, entityName = 'APPLICATION' }) => {
            filter = filter || {
                $inlinecount: 'allpages',
                $filter: `EntityType eq '${entityName}' and Status eq 'ENABLED'`,
            };
            const url = new URL(`${context.apiUrl}${basePath}`);
            url.search = stringify(filter);
            const { json } = await context.fetchJson(url.toString(), {
                credentials: 'include',
            });
            if (!json) {
                return { data: [] };
            }
            return {
                data: json.map((_a) => {
                    var { Uuid } = _a, item = __rest(_a, ["Uuid"]);
                    return (Object.assign(Object.assign({}, item), { id: Uuid }));
                }) || [],
                total: json.length,
            };
        },
    };
};
//# sourceMappingURL=customFields.js.map